<!--
 * @Author: cmchiu
 * @Date: 2022-03-31 17:16:57
 * @LastEditTime: 2023-06-27 16:40:11
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\views\Home.vue
 * 
-->
<template>
    <div class="home">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-10">
                    <section class="section-right-shape padding-bottom padding-top news-block">
                        <div class="container">
                            <div class="row">
                                <!-- 輪播BN -->
                                <div class="col-lg-4 col-md-12 col-12">
                                    <banner />
                                </div>
                                <!-- 輪播BN End -->

                                <!-- 公告 -->
                                <div class="col-lg-8">
                                    <div class="mobile-style row">
                                        <div
                                            class="col-lg-5 col-md-4 col-4"
                                            style="border-top: 0.1em solid #0e7767"
                                        ></div>
                                        <div class="col-lg-2 col-md-4 col-4">
                                            <div class="section-header">
                                                <span class="cate">最新消息</span>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-5 col-md-4 col-4"
                                            style="border-top: 0.1em solid #0e7767"
                                        ></div>
                                    </div>

                                    <news height="100%" pageLimit="1" showMore />
                                </div>
                                <!-- 公告End -->
                            </div>
                        </div>
                    </section>

                    <section style="background-color: #f2f2f2" class="disseminate">
                        <div class="container">
                            <div class="row text-center">
                                <!-- 性別平等教育委員會 -->
                                <div class="col-lg-2 col-md-2 col-4 disseminate-cell">
                                    <div
                                        class="service_block"
                                        @click="go2WebSite(url.geec)"
                                        title="性別平等教育委員會（另開視窗）"
                                        tabindex="0"
                                        role="link"
                                    >
                                        <img :src="`${baseUrl}assets/images/c01.png`" alt="性別平等教育委員會" />
                                    </div>
                                    <div
                                        class="mt-2 service_block_title"
                                        @click="go2WebSite(url.geec)"
                                        title="性別平等教育委員會（另開視窗）"
                                        role="link"
                                    >
                                        <p>性別平等教育委員會</p>
                                    </div>
                                </div>

                                <!-- 校外賃居網 -->
                                <div class="col-lg-2 col-md-2 col-4 disseminate-cell">
                                    <div
                                        class="service_block"
                                        @click="go2WebSite(url.house)"
                                        title="校外賃居網（另開視窗）"
                                        tabindex="0"
                                        role="link"
                                    >
                                        <img :src="`${baseUrl}assets/images/c02.png`" alt="校外賃居網" />
                                    </div>
                                    <div
                                        class="mt-2 service_block_title"
                                        @click="go2WebSite(url.house)"
                                        title="校外賃居網（另開視窗）"
                                        role="link"
                                    >
                                        <p>校外賃居網</p>
                                    </div>
                                </div>

                                <!-- 無菸校園 -->
                                <div class="col-lg-2 col-md-2 col-4 disseminate-cell">
                                    <div
                                        class="service_block"
                                        @click="go2WebSite(url.nosmoking)"
                                        title="無菸校園（另開視窗）"
                                        tabindex="0"
                                        role="link"
                                    >
                                        <img :src="`${baseUrl}assets/images/c03.png`" alt="無菸校園" />
                                    </div>
                                    <div
                                        class="mt-2 service_block_title"
                                        @click="go2WebSite(url.nosmoking)"
                                        title="無菸校園（另開視窗）"
                                        role="link"
                                    >
                                        <p>無菸校園</p>
                                    </div>
                                </div>

                                <!-- 智慧財產權 -->
                                <div class="col-lg-2 col-md-2 col-4 disseminate-cell">
                                    <div
                                        class="service_block"
                                        @click="go2WebSite(url.ipr)"
                                        title="智慧財產權（另開視窗）"
                                        tabindex="0"
                                        role="link"
                                    >
                                        <img :src="`${baseUrl}assets/images/c04.png`" alt="智慧財產權" />
                                    </div>
                                    <div
                                        class="mt-2 service_block_title"
                                        @click="go2WebSite(url.ipr)"
                                        title="智慧財產權（另開視窗）"
                                        role="link"
                                    >
                                        <p>智慧財產權</p>
                                    </div>
                                </div>

                                <!-- 防制校園霸凌 -->
                                <div class="col-lg-2 col-md-2 col-4 disseminate-cell">
                                    <div
                                        class="service_block"
                                        @click="go2WebSite(url.bullying)"
                                        title="防制校園霸凌（另開視窗）"
                                        tabindex="0"
                                        role="link"
                                    >
                                        <img :src="`${baseUrl}assets/images/c05.png`" alt="防制校園霸凌" />
                                    </div>
                                    <div
                                        class="mt-2 service_block_title"
                                        @click="go2WebSite(url.bullying)"
                                        title="防制校園霸凌（另開視窗）"
                                        role="link"
                                    >
                                        <p>防制校園霸凌</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- 活動快訊 -->
                    <section class="padding-bottom padding-top bg_img new-active-block">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-5 col-md-4 col-4" style="border-top: 0.1em solid #0e7767"></div>
                                <div class="col-lg-2 col-md-4 col-4">
                                    <div class="section-header">
                                        <span class="cate">活動快訊</span>
                                    </div>
                                </div>
                                <div class="col-lg-5 col-md-4 col-4" style="border-top: 0.1em solid #0e7767"></div>
                            </div>

                            <new-active pageLimit="1" showMore />
                        </div>
                    </section>
                    <!--活動快訊End -->
                </div>

                <!-- 行事曆 -->
                <div class="col-xl-2 d-none d-xl-block">
                    <section class="padding-bottom padding-top">
                        <div class="calendar_title">
                            <img :src="`${baseUrl}assets/images/calendar.png`" alt="logo" />&nbsp;
                            <span>行事曆</span>
                        </div>

                        <calendar-ls></calendar-ls>
                    </section>
                </div>
                <!-- 行事曆 End -->
            </div>
        </div>

        <!-- 緊急公告 -->
        <notice />
        <!-- 緊急公告 End -->
    </div>
</template>

<script>
// import axios from 'axios'
// import XEUtils from 'xe-utils'
import { banner } from '@c/Banner'
import { notice } from '@c/Notice'
import { news } from '@c/News'
import { newActive } from '@c/NewActive'
import { calendarLs } from '@c/CalendarList'
import settings from '@/settings.js'

export default {
    name: 'Home',

    components: { banner, notice, news, newActive, calendarLs },

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            loading: false,
            url: settings.url,
        }
    },

    created: function () {},

    methods: {
        go2Page(page) {
            this.$router.push(page)
        },

        go2WebSite(url) {
            window.open(url)
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.infinite-list-wrapper {
    width: 100%;
    /* height: 450px; */
    border: 0.1em solid rebeccapurple;
}
:deep .loading-mask {
    top: 0;
    height: 200px;
}
.disseminate {
    // padding: 40px 0;

    .container {
        padding: 0 0.8em;
        padding-top: 1em;

        .row {
            justify-content: flex-start !important;

            .disseminate-cell {
                .service_block {
                    width: 5.5em;
                    height: 5.5em;

                    img {
                        width: 4.5rem;
                    }
                }
            }
        }
    }
}
.news-block {
    padding-bottom: 50px;
}
.new-active-block {
    padding-top: 60px;
}
.mobile-style {
    padding-top: 30px;
}
@media screen and (min-width: 993px) {
    .news-block {
        padding-bottom: 60px;
    }
    .new-active-block {
        padding-top: 70px;
    }
    .mobile-style {
        display: none;
    }

    .disseminate {
        padding: 0.1em 0;

        .container {
            margin-top: 2.188em;
            padding: 0;

            .row {
                justify-content: space-around !important;

                .disseminate-cell {
                    .service_block {
                        width: 8.5em;
                        height: 8.5em;

                        img {
                            width: 7em;
                        }
                    }
                    .service_block_title {
                        margin-bottom: 1.5em;
                    }
                }
            }
        }
    }
}
</style>
